import { render, staticRenderFns } from "./FIBEmoji.vue?vue&type=template&id=2eb27a5a&"
import script from "./FIBEmoji.vue?vue&type=script&lang=js&"
export * from "./FIBEmoji.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QRadio});
